import React from 'react';
function Esl({ data, status }) {
    if (status && status?.includes('OFFICIAL')) return <></>;
    return (
        data && <div className="mirs-esl text-wrap text-start">{data}</div>
    )
}


export default Esl;